<vw-modal
  *ngIf="isOpen"
  [title]="(!showAdjust ? 'cookie.title' : 'cookie.adjustTitle') | translate"
>
  <p *ngIf="!showAdjust">{{ "cookie.disclaimer" | translate }}</p>
  <div *ngIf="showAdjust">
    <vw-checkbox
      [id]="'cookie-consent-form-required'"
      [label]="'cookie.required' | translate"
      [parentForm]="cookiesForm"
      [formControlProp]="'required'"
    ></vw-checkbox>
    <p>
      {{ "cookie.requiredBody" | translate }}<br />
      <a
        [routerLink]="['/', themeService.brand || '', 'cookies']"
        [fragment]="'TABLE_REQUIRED'"
        (click)="close()"
        >{{ "cookie.readMore" | translate }}</a
      >
    </p>

    <vw-checkbox
      [id]="'cookie-consent-form-functional'"
      [label]="'cookie.functional' | translate"
      [parentForm]="cookiesForm"
      [formControlProp]="'functional'"
    ></vw-checkbox>
    <p>
      {{ "cookie.functionalBody" | translate }}<br />
      <a
        [routerLink]="['/', themeService.brand || '', 'cookies']"
        [fragment]="'TABLE_FUNCTIONAL'"
        (click)="close()"
        >{{ "cookie.readMore" | translate }}</a
      >
    </p>

    <vw-checkbox
      [id]="'cookie-consent-form-performance'"
      [label]="'cookie.performance' | translate"
      [parentForm]="cookiesForm"
      [formControlProp]="'performance'"
    ></vw-checkbox>
    <p>
      {{ "cookie.performanceBody" | translate }}<br />
      <a
        [routerLink]="['/', themeService.brand || '', 'cookies']"
        [fragment]="'TABLE_PERFORMANCE'"
        (click)="close()"
        >{{ "cookie.readMore" | translate }}</a
      >
    </p>

    <vw-checkbox
      [id]="'cookie-consent-form-marketing'"
      [label]="'cookie.marketing' | translate"
      [parentForm]="cookiesForm"
      [formControlProp]="'marketing'"
    ></vw-checkbox>
    <p>
      {{ "cookie.marketingBody" | translate }}<br />
      <a
        [routerLink]="['/', themeService.brand || '', 'cookies']"
        [fragment]="'TABLE_MARKETING'"
        (click)="close()"
        >{{ "cookie.readMore" | translate }}</a
      >
    </p>
  </div>

  <ng-container actions>
    <ng-container *ngIf="!showAdjust">
      <button
        [vw]
        class="action action__consent-min"
        [light]="true"
        (click)="consentMinimal()"
      >
        {{ "cookie.consent-minimal" | translate }}
      </button>
      <button
        [vw]
        class="action action__adjust"
        [light]="true"
        (click)="goToAdjust()"
      >
        {{ "cookie.adjust" | translate }}
      </button>
      <button
        [vw]
        class="action action__consent-all"
        [primary]="true"
        (click)="consentAll()"
      >
        {{ "cookie.consent-all" | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="showAdjust">
      <button
        [vw]
        class="action action__save"
        type="button"
        [primary]="true"
        (click)="consentForm()"
      >
        {{ "cookie.save" | translate }}
      </button>
    </ng-container>
  </ng-container>
</vw-modal>
